import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 50vh;
`;

const StyledBody = styled.div`
  max-width: 600px;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 20px;
  margin-top: 40px;
  flex-grow: 1;

  p {
    font-family: "FuturaPT-Book";
    ${({ isMobile }) =>
      isMobile
        ? "font-size: 16px; line-height: 28px; letter-spacing: 0px;"
        : "margin: 20px 0 20px 0; font-size: 21px; line-height: 30px; letter-spacing: 0.31px;"}
  }
`;

const StyledHeading = styled.div`
  font-family: "Ogg-Regular";
  font-style: normal;
  font-weight: normal;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 1px;
  text-transform: capitalize;
  max-width: 600px;
  text-align: center;
  margin-bottom: 60px;
  ${({ isMobile }) => (isMobile ? "margin-top: 20px;" : "")}
`;

export { StyledWrapper, StyledBody, StyledHeading };
